module.exports = "/_next/static/images/DevNation2-a1028b2078cbf05562310ea77c453a9e.jpg";